const clean = (value) => String(value ?? "").trim()

const positiveQty = (value) => {
  const qty = Number(value)
  return Number.isFinite(qty) && qty > 0 ? qty : null
}

/** Article lines already stored on the booking (parcel rows, else shipment article_type). */
export const shipmentArticleItems = (shipment) => {
  const parcels = Array.isArray(shipment?.parcels) ? shipment.parcels : []
  const items = []
  parcels.forEach((parcel) => {
    const name = clean(parcel?.package_name || parcel?.article_type)
    if (!name) return
    items.push({ name, qty: positiveQty(parcel?.qty) })
  })
  if (items.length) return items

  const fallback = clean(shipment?.article_type)
  if (!fallback) return []
  return [{ name: fallback, qty: positiveQty(shipment?.no_of_articles) }]
}

/** Single name, or "Name × qty" for each line when a shipment has several articles. */
export const formatShipmentArticles = (shipment) => {
  const items = shipmentArticleItems(shipment)
  if (!items.length) return ""
  if (items.length === 1) return items[0].name
  return items
    .map((item) => (item.qty != null ? `${item.name} × ${item.qty}` : item.name))
    .join(", ")
}

/** Booking quantity: no_of_articles, else the sum of parcel quantities. */
export const shipmentQuantity = (shipment) => {
  const header = positiveQty(shipment?.no_of_articles)
  if (header != null) return header
  const sum = shipmentArticleItems(shipment).reduce((total, item) => total + (item.qty || 0), 0)
  return sum > 0 ? sum : null
}

const hubLabel = (shipment, locationKey, hubKey) => {
  const stored = clean(shipment?.[locationKey])
  if (stored) return stored
  const hub = shipment?.[hubKey]
  return clean(hub?.display_label || hub?.location)
}

/** Sender / from branch. sender_location is already the hub branch label. */
export const shipmentSenderBranch = (shipment) => hubLabel(shipment, "sender_location", "sender_location_hub")

/** Receiver / to branch. receiver_location is already the hub branch label. */
export const shipmentReceiverBranch = (shipment) => hubLabel(shipment, "receiver_location", "receiver_location_hub")
